// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"projects_signup_src_app_public_public_module_ts":"1cf79a686f9fa41c","projects_signup_src_app_public_signup_signup_module_ts":"e9d805ce96b82c8b","node_modules_ngx-quill_fesm2022_ngx-quill-quill-CUw8Q_m0_mjs":"8eb1f076921bf427"}[chunkId] + ".js";
};